import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import AppSelectFormik from "components/formik/AppSelectFormik";
import { Formik } from "formik";
import * as Yup from "yup";
import AppButton from "components/FormsUI/AppButton/appButton";
import AppFormField from "components/formik/AppFormField";
import { AiOutlineClear } from "react-icons/ai";
import { BsFillCursorFill } from "react-icons/bs";
import { findOptionByValue } from "utils/common-utils";
import UsersService from '../../../services/users.service';
import AirlinesService from '../../../services/airlines.servicse';
import ToastContext from "store/ToastContext";
import AppSpinner from "components/common/AppSpinner";


const patternName = new RegExp(/^[a-zA-Z- ]+$/);
const patternCallNumber = RegExp(/^\+(?:[0-9]?){6,14}[0-9]$/);

const AdminSchema = Yup.object().shape({
  UserName: Yup.string()
    .email("Please enter valid email address.")
    .required("Required"),
  FirstName: Yup.string()
    .matches(patternName, "Please enter valid First Name.")
    .required("Required"),
  LastName: Yup.string()
    .matches(patternName, "Please enter valid Last Name.")
    .required("Required"),
  PhoneNumber: Yup.string()
    .matches(patternCallNumber, "Please enter valid Phone Number.")
    .required("Required"),
  FaxNumber: Yup.string()
    .matches(patternCallNumber, "Please enter valid Fax Number.")
    .nullable(),
  Airline: Yup.object()
    .shape({ value: Yup.string().required() })
    .nullable()
    .required("Required"),
});


const AdministratorNewEditForm = (props) => {
  const { adminUser = null } = props;
  const { openToast } = useContext(ToastContext);
  const [airlinesOptions, setAirlinesOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isInitDone, setisInitDone] = useState(false);
  const isUpdateMode = !!adminUser;

  useLayoutEffect(() => {
    if(!adminUser){
      setisInitDone(false);
        AirlinesService.GetAirlinesWithoutAdministrator()
          .then(data => {
            setAirlinesOptions(data);
            setisInitDone(true);
          })
          .catch(data => {
              setAirlinesOptions([]);
              setisInitDone(true);
            }
          );
    }
  }, [adminUser])

  useEffect(() => {
    if(adminUser){
      if(props.state?.type === "airlines"){
        setisInitDone(!props.state.payload.isLoading);
        setAirlinesOptions(props.state.payload.airlines);
      }
    }
  }, [props.state,adminUser])

  const handleSubmit = async (values) => {
    setIsLoading(true);
    const req = {
      ...values,
      AirlineCode: values.Airline.value,
      Role: "admin"
    }
    let actionResult;
    if(isUpdateMode){
      actionResult = await UsersService.updateUser(req);
    } else {
      actionResult = await UsersService.addAdmin(req);
    }
    if (actionResult.code === 0) {
      openToast(actionResult.description, "success");
      props.onResolve(true);
    } else {
      openToast(`Error ${actionResult.description}`, "error", {duration: 8000});
      setIsLoading(false);
    }
  }

  return (
    isInitDone ?
    <Formik
        initialValues={{
            UserName: adminUser?.userName ? adminUser.userName : "",
            FirstName: adminUser?.firstName ? adminUser.firstName : "",
            LastName: adminUser?.lastName ? adminUser.lastName : "",
            PhoneNumber: adminUser?.phoneNumber ? adminUser.phoneNumber : "",
            FaxNumber: adminUser?.faxNumber ? adminUser.faxNumber : "",
            Airline: adminUser?.airlineCode ? findOptionByValue(adminUser.airlineCode, airlinesOptions) : null
        }}
        validationSchema={AdminSchema}
        onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            handleSubmit(values);
          }}
        >
            {(formik) => (
                <form noValidate onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item xs={12} className="mb-2">
                        <AppSelectFormik
                            name="Airline"
                            isClearable={true}
                            options={airlinesOptions}
                            label="Airline"
                            variant="simple"
                            disabled={isUpdateMode}
                            {...formik}
                            />
                    </Grid>
                    <Grid item xs={12} className="mb-2">
                        <AppFormField 
                            name="UserName" 
                            label="User name"
                            disabled={isUpdateMode}
                            {...formik}
                        />
                    </Grid>
                    <Grid item xs={6} className="mb-2">
                        <AppFormField 
                            name="FirstName" 
                            label="First name"
                            {...formik}
                        />
                    </Grid>
                    <Grid item xs={6} className="mb-2">
                        <AppFormField 
                            name="LastName" 
                            label="Last name"
                            {...formik}
                            />
                    </Grid>
                    <Grid item xs={6} className="mb-2">
                        <AppFormField 
                            name="PhoneNumber" 
                            label="Phone number"
                            {...formik}
                            />
                    </Grid>
                    <Grid item xs={6} className="mb-2">
                        <AppFormField 
                            name="FaxNumber" 
                            label="Fax number"
                            {...formik}
                            />
                    </Grid>
                    <Grid container className="mt-3 mb-2 px-2">
                        <Grid item xs></Grid>
                        {!isUpdateMode &&
                          <Grid item xs={2} className="mx-2">
                              <AppButton action={formik.resetForm} id="adminFormClearBtn" label="Clear" color="danger" icon={<AiOutlineClear />} isBlock={true} disabled={isLoading}
                              ></AppButton>
                          </Grid>
                        }
                        <Grid item xs={2}>
                            <AppButton id="adminFormSubmitBtn" type="submit" label="Submit" 
                             icon={<BsFillCursorFill />} isBlock={true} isLoading={isLoading}
                            ></AppButton>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            )}
        </Formik> :
        <Grid item xs={12}>
          <div
            className="marginAtTop"
            style={{ textAlign: "center" }}>
            <AppSpinner/>
          </div>
        </Grid>
  )
};

export default AdministratorNewEditForm;
